const ENVIRONMENTS = {
  prod: {
    apiBaseUrl: "https://conp7mdcya.execute-api.eu-central-1.amazonaws.com/prod",
    graphQlEndpoint:
      "https://kcreftgj3rdbtc2bsefmlxuqxq.appsync-api.eu-central-1.amazonaws.com/graphql",
    graphQlApiKey: "da2-dtqhlag745e6xlmrcbyprdebxe",
    graphQlRegion: "eu-central-1",
  },
  dev: {
    apiBaseUrl: "https://mw2dd18d63.execute-api.eu-central-1.amazonaws.com/dev",
    graphQlEndpoint:
      "https://tzhry6564nahtedhwvvw7dlpja.appsync-api.eu-central-1.amazonaws.com/graphql",
    graphQlApiKey: "da2-embrqju2xjdybjuoac3pmpq6de",
    graphQlRegion: "eu-central-1",
  },
};

const stage =
  process.env.REACT_APP_AQUACONTROL_STAGE ||
  (process.env.NODE_ENV === "development" ? "dev" : "prod");

const selectedEnvironment = ENVIRONMENTS[stage] || ENVIRONMENTS.prod;

export const AQUACONTROL_ENV = {
  stage,
  ...selectedEnvironment,
};
